module.exports = __webpack_public_path__ + "media/4.bd6b3a33.wav";